import { createSlice } from "@reduxjs/toolkit";
import {
  fetchApplications,
  fetchApplicationsByUuid,
} from "./applications-async-calls";
import { ApplicationsSliceState } from "./applications-interface";

const initialState: ApplicationsSliceState = {
  applications: [],
  selectedApplication: null,
  isFetching: false,
};

const applicationsSlice = createSlice({
  name: "applications",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplications.pending, (state) => {
        state.applications = [];
        state.isFetching = true;
      })
      .addCase(fetchApplications.fulfilled, (state, action) => {
        state.applications = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchApplications.rejected, (state) => {
        state.applications = [];
        state.isFetching = false;
      })
      .addCase(fetchApplicationsByUuid.pending, (state) => {
        state.selectedApplication = null;
        state.isFetching = true;
      })
      .addCase(fetchApplicationsByUuid.fulfilled, (state, action) => {
        state.selectedApplication = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchApplicationsByUuid.rejected, (state) => {
        state.selectedApplication = null;
        state.isFetching = true;
      });
  },
});

export const {} = applicationsSlice.actions;

export default applicationsSlice.reducer;
